export default [
  {
    path: "/appAnalytics",
    name: "AppAnalytics",
    meta: { descricao: "AppAnalytics" },
    component: () => import("@/pages/app_analytics/AppAnalytics")
  }
];
